import { Container, Grid } from '@mui/material';
import { t } from 'i18next';
import { DELETE_USER, GET_USER } from 'src/apiService/apiDeclaration';
import { ICONS } from 'src/assets/library';
import CustomerOrdersModal from 'src/components/common/CustomerOrdersModal';
import EditCustomerForm from 'src/components/form/EditCustomerForm';
import MenuPopover from 'src/components/menu/menu';
import PageHeader from 'src/components/pageHeader/PageHeader';
import CustomTable from 'src/components/table/table';
import TabTitle from 'src/components/tabTitle/tabTitle';
import { showErrorTost, showSuccessTost } from 'src/constants';
import { customerTableColumns } from 'src/constants/columnConfig';
import { useModal } from 'src/hooks/useModal';
import usePagination from 'src/hooks/usePagination';

const CustomerPage = () => {
  const { setDialogData, handleModalClose } = useModal();
  const { paginationModel, setPaginationModel, loading, data, refresh } = usePagination(GET_USER, {
    role: 'CUSTOMER',
  });
  const updatedUserTable = [...customerTableColumns];

  const onSuccess = () => {
    handleModalClose();
    refresh();
  };
  const onDelete = async (id) => {
    try {
      await DELETE_USER(id);
      onSuccess();
      showSuccessTost(t('common.customerDeleteSuccessMessage'));
    } catch (error) {
      console.log(error);
      showErrorTost(t('common.customerDeleteFailureMessage'));
    }
  };

  updatedUserTable.push({
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: ({ row }) => {
      return (
        <MenuPopover
          menuArray={[
            {
              icon: ICONS.order,
              name: t('customerPage.viewOrders'),
              action: () => {
                const customerName = `${row.firstName || ''} ${row.lastName || ''}`.trim();
                setDialogData({
                  showModal: true,
                  title: `${t('customerPage.customerOrders')} - ${customerName}`,
                  child: <CustomerOrdersModal customerId={row._id} />,
                });
              },
            },
            {
              icon: ICONS.delete,
              name: t('menu.deleteCustomer'),
              action: () => {
                setDialogData({
                  showModal: true,
                  description: t('common.delConfirmation'),
                  onConfirm: () => onDelete(row._id),
                });
              },
            },
            {
              icon: ICONS.edit,
              name: t('menu.editCustomer'),
              action: () => {
                setDialogData({
                  showModal: true,
                  title: t('menu.editCustomer'),
                  child: <EditCustomerForm onSuccess={() => onSuccess()} data={{ ...row }} />,
                });
              },
            },
          ]}
        />
      );
    },
  });
  return (
    <Container>
      <Grid container spacing={2}>
        <TabTitle title={'Customers'} />
        <Grid item xs={12}>
          <PageHeader pageTitle={t('navMenu.customer')} />
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            loading={loading}
            isServerSidePagination
            paginationModel={paginationModel}
            columns={updatedUserTable}
            setPaginationModel={setPaginationModel}
            rows={data.rows}
            rowCount={data.rowCount}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default CustomerPage;
